import { getStore } from '../store/store';

export function getModalDialogShownCount(): number {
    return getStore().modalDialogShownCount;
}
